import { Icon } from '@iconify/react'
import { Alert } from 'antd'
import React, { FunctionComponent } from 'react'

import { IncreasingNumber } from '../IncreasingNumber/IncreasingNumber'

export interface CadastralWorkplaceSelectionFooterCounterProps {
  selected: {
    workplacesCount: number
    outOfTotal: number
    price: number
  }
}

export const CadastralWorkplaceSelectionFooterCounter: FunctionComponent<CadastralWorkplaceSelectionFooterCounterProps> =
  ({ selected }) => {
    return (
      <Alert
        className={`!px-2 !py-1 ${selected.workplacesCount ? '' : 'grayscale'}`}
        message={
          <div className={`${selected.workplacesCount ? '' : 'text-gray-500'}`}>
            <span className="mr-2">
              Vybraných pracovišť:{' '}
              <IncreasingNumber
                className="font-bold"
                finalNumber={selected.workplacesCount}
                decimal={0}
              />
              {' z '}
              {selected.outOfTotal}
            </span>
            {!!selected.price && (
              <span className="mr-2">
                Celková cena:{' '}
                <IncreasingNumber
                  className="font-bold"
                  finalNumber={selected.price}
                />{' '}
                Kr.
              </span>
            )}
          </div>
        }
        type="success"
        showIcon={!!selected.price}
        icon={<Icon icon="ph:shopping-cart" width="18" />}
      />
    )
  }
